import { Paragraph } from "../../Paragraph";
import styled from "styled-components";

export const FullDate = styled(Paragraph)`
  padding: 10px 0;
`;
